module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("3")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("“W")])])])]), _vm._v("hen you pull up to the gate,” Peter said, “just enter my code—four three nine nine.” He demonstrated. “And the gates will open.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("They did, swinging back like great black wings, welcoming Carlotta into the privileged neighborhood of Martinique Estates. Peter’s Porsche two-seater surged forward, like a giant cougar. The guard at the pristinely designed gatehouse waved as they drove by.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Cruising past palatial custom homes, Carlotta was struck with a sense of déjà vu. She and her family had once lived in a private subdivision like this one. They’d belonged to the neighborhood pool and volleyed on the neighborhood tennis courts. But these days, in addition to the multiple pools and other shared amenities, individual home owners, like Peter, were likely to have their own pool and their own private add-ons.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Each home was its own little estate.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('span', [_vm._v("When he pulled in to the downward-sloping driveway of his sprawling brick home, Carlotta had to catch her breath. She had seen it before, of course, but not in daylight, and not through the eyes of someone who would be living there. The house was impressive, with a paved ")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("circular driveway in front that featured a huge fountain, with wide steps leading to the two-story entryway. Palladium windows and gleaming white trim gave the eye a pleasing break from the intimidating mass of brick. The landscaping was lush and flawlessly manicured.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', [_vm._v("To the right of the house was the pool. Carlotta was glad it was daylight. The memory of seeing Peter’s wife, Angela, lying under night-lights next to the pool where she’d drowned was branded onto Carlotta’s brain. But in the brightness of day, with the sun high and the trees full, it was tempting to believe that the tragedy hadn’t happened in this perfect neighborhood.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', [_vm._v("Peter touched a button on his visor and one of the doors to a four-car garage opened, revealing his other vehicle, an SUV. She assumed he’d sold Angela’s Jaguar.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', [_vm._v("“My insurance company is sending a rental car tomorrow,” she murmured, remembering her own transportation situation. As much as she’d hated the blue Monte Carlo, she hadn’t wanted to see it blown to smithereens, not when she owed more on it than it was worth.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', [_vm._v("“Nonsense,” Peter said. “You can drive the convertible, or the SUV, whichever you prefer.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', [_vm._v("“Peter, I couldn’t.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', [_vm._v("“Why not? Otherwise one of them will just be sitting in the garage while you drive a rental. That doesn’t make sense.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', [_vm._v("She hesitated. “It just doesn’t seem right. People will talk.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', [_vm._v("“People are going to talk anyway.” He gestured to another house before pulling in to the garage. “My next-door neighbor is in the Junior League, so I figure Tracey Lowenstein will know about our situation in less than twenty-four hours.”")])])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Tracey Tully Lowenstein, renowned socialite and daughter to Walt Tully, Carlotta’s godfather and her father’s former partner at what used to be Mashburn, Tully & Wren Investments. When Carlotta’s father had been indicted for fraud, the name Wren had been removed from the firm’s letterhead, and from the Buckhead social register. Tracey seemed single-handedly determined that Carlotta would not be readmitted to the upper echelon.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“And I don’t care,” Peter added, putting the car into Park and turning off the engine.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I have to buy a car soon, or get the Miata fixed.” Although one would probably cost as much as the other. And with her wrecked credit still on the mend, she probably wouldn’t qualify for a new car loan—or for financing to get the Miata repaired.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You don’t have to rush into anything,” he said. “While you’re here, use the extra car.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Carlotta pressed her lips together. His argument seemed logical, but Peter always seemed logical. It was how he had talked her into accepting a cell phone on his plan, because the incremental cost to him was negligible, while she couldn’t get a new one until her credit mess was straightened out.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He reached over to cover her hand with his. “Let me spoil you, Carly.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('span', [_vm._v("His blue eyes were so sincere. Shortly before Angela’s death, she had run into Peter at a cocktail party she’d crashed and thought she would die from wanting him. He had turned out to be everything they had planned he would be—successful and wealthy. Married and living in a world that had shunned her, he had seemed so far out of her reach. But he’d kissed her that night, had told her that his ")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("marriage to Angela wasn’t good, and that he wanted Carlotta back in his life. When Angela had died a violent death and Peter had been blamed, it seemed that once again, all was lost…especially when Peter had confessed to his wife’s murder. But in the end, it was revealed that Angela had been living the double life of a Buckhead housewife and a high-class call girl. Peter had confessed to protect the reputation of a woman he felt he’d driven to reckless behavior with his indifference.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('span', [_vm._v("The experience had endeared him to Carlotta, and even though he came out of it a free man, she had felt that it was too soon, that they were both too raw to resume their relationship. And then there was Jack…and Coop…")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('span', [_vm._v("“Drive the Porsche,” he said, gesturing to the interior of the luxurious car. “Have fun.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('span', [_vm._v("“What if I do something to it?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('span', [_vm._v("“That’s what insurance is for.” Then he winked. “Besides, if I can’t get you to fall in love with me again, maybe you’ll fall in love with my car.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('span', [_vm._v("She laughed and stroked the armrest. “It is beautiful.” Then she smiled. “Okay, but only until I get the Miata fixed.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('span', [_vm._v("“Fair enough. Let’s go inside. I’ll get your suitcase.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('span', [_vm._v("Carlotta stepped out of the car and glanced around the garage that was nearly as big as the town house she and Wesley shared.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('span', [_vm._v("“I’m starved,” Peter said, energetically pulling her bulky bag out of the small car trunk. “I think that zap you gave me stirred my appetite. I was thinking of grilling out by the pool. How does that sound?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('span', [_vm._v("Her mouth parted in surprise, then she chided herself. Peter couldn’t very well live in this house and forever ")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("avoid the place where Angela had drowned. “That sounds fine. Do you grill?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('span', [_vm._v("He looked sheepish as he moved toward the door leading to the house. “I’m learning, if you don’t mind being a test subject.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('span', [_vm._v("She laughed. “I don’t mind. Wesley does all the cooking in our house.” She hesitated before following him inside, feeling self-conscious. She stepped into what appeared to be a mudroom that contained a door to a powder room and a wide closet.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('span', [_vm._v("“The laundry room is behind those doors,” he said, pointing. “My housekeeper, Flaur, will take care of your clothes.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('span', [_vm._v("“Oh, that’s not necessary,” she said quickly. Except for the clothes that Michael Lane had inexplicably washed, dried and folded while she and Wesley were away from the house, she was accustomed to taking care of her own laundry.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('span', [_vm._v("In the mudroom, several of Peter’s jackets hung on a Peg-Board and a couple of pairs of knockabout shoes sat on the floor. They walked through another door to enter a spacious great room, which brought back more memories of that night. Straight ahead was a jaw-dropping kitchen, to her right, a den and sunroom with an eating area, flanked by sliding glass doors that led out to the pool area.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('span', [_vm._v("The long wood table in the sunroom was where she’d sat with Peter, consoling him after Angela’s body had been found. The garish “designer” silk flower arrangement that had sat on the table, the one Peter said he and Angela had argued over because of the expense, was gone, replaced by a demure lidded vase. The wall of cherrywood book")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("shelves in the den above the fireplace were studded with bric-a-brac, but seemed more streamlined than before. Peter had obviously removed some of Angela’s possessions from his home, yet her influence remained in splashes of feminine color and the occasional designer collectible. And in a single framed black-and-white picture of Angela taken in happier times.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('span', [_vm._v("Wood-lined ceilings soared overhead, with more wood at their feet, polished to a shine. The first floor also featured a formal living room, a formal dining room, an office, a butler’s pantry and a home theater.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('span', [_vm._v("“Wesley would love this,” she said, gesturing to the plasma TV and surround-sound speakers.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('span', [_vm._v("“He’s welcome to come over anytime and use it,” Peter offered. “My house could use some living.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('span', [_vm._v("“It’s such a lovely home, Peter,” she said, running her hand over the curved moldings of a chair rail. Every element of every room was finely designed and crafted. “Did you and Angela build it?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('span', [_vm._v("“Yes. Angie selected all the finishing details and the decor.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('span', [_vm._v("The implication hung in the air between them—if they’d married instead, Carlotta would’ve been the one sorting through Italian-tile samples and choosing custom-cabinet hardware. She knew that Peter was wealthy in his own right, and would inherit another fortune when his parents passed, but seeing firsthand how he lived—how she might’ve lived—left her feeling a little light-headed.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('span', [_vm._v("“Angela had good taste,” she said finally.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('span', [_vm._v("He nodded, then retrieved her suitcase and gestured toward the stairs—one of two staircases, she’d learned ")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("during the tour. “I’ll show you your room and you can unpack while I get dinner started.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('span', [_vm._v("She followed him, holding on to the handrail as she climbed the wide staircase. Ahead of her, Peter was animated as he pointed out different rooms and some of the pieces of art that he particularly liked. He seemed almost giddy to have her there, but Carlotta felt a heaviness all around her, as if there was a presence in the house…Angela’s aura.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('span', [_vm._v("Then she gave herself a mental shake at her absurdity. Angela was gone, and Peter was ready to move on.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('span', [_vm._v("Still…it felt eerie to be given full run of the woman’s house, especially in light of Angela’s outright dislike of her. Carlotta couldn’t blame her, though. During the investigation of the woman’s death, it was revealed that Peter carried a picture of Carlotta in his wallet. Angela must have known, and it had to have eaten at her.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('span', [_vm._v("“This is my room,” he said, stopping to allow Carlotta to peek inside. The room was enormous, with an elaborately trayed ceiling and skylight. At the end of the room was a sitting area, with a fireplace and flat-screen TV, with a veranda beyond sets of French doors.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('span', [_vm._v("Near the bed, she saw a dressing room through a doorway that she assumed serviced his-and-her walk-in closets. Through another doorway she glimpsed the bathroom and a waterfall shower.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('span', [_vm._v("The bedroom furniture was dark and heavy and of the highest quality—the king-size bed alone had probably cost as much as his Porsche, she surmised, picturing Peter’s long frame stretched out on its length. The linens and curtains were earth toned and sumptuous, the inlaid designs in the wood floor a masterpiece. She wondered if ")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("he kept the Cartier engagement ring he was “holding” for her somewhere in this room.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('span', [_vm._v("“It’s…wonderful,” she murmured, but shrank a little inside, mortified at what he must think of her housing situation. When she moved back to the town house, things had to change.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('span', [_vm._v("“I’m glad you like it,” Peter said. “The room I had in mind for you is across the hall.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('span', [_vm._v("She followed him to a set of double doors that opened into a suite that was as light as his was dark. The furniture was maple, the linens fresh and airy, the area rugs plush. It was feminine in every sense, including the enormous closet and the spalike bathroom. Angela’s influence was apparent in every corner of this space. “It’s wonderful,” Carlotta murmured.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('span', [_vm._v("“There are three other guest rooms if this one doesn’t suit you, including one in the basement.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('span', [_vm._v("Her eyes widened. “You have a basement?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('span', [_vm._v("He grinned. “Where else would I put the game room and wine cellar?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('span', [_vm._v("“Where else indeed?” Carlotta did a full turn in the center of the room, noticing that she had a veranda of her own, facing the front of the house, where the veranda off Peter’s room faced the rear. “It’s positively lovely, Peter. I feel like a princess.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('span', [_vm._v("“Good,” he said, then picked up a lock of her hair. “You deserve to feel like a princess. Take your time settling in. When you come down, I’ll show you the alarm system so you’ll feel safe when you’re here alone.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('span', [_vm._v("“Okay.” When he closed the door behind him, she fell backward on the luxurious bed, enjoying the bounce of the mattress. She gazed up at a skylight that was lined with ")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("prisms, turning the sun’s waning light into a thousand shimmering rainbows. Her life up until now seemed a thousand miles away.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('span', [_vm._v("“Oh,” Carlotta sighed, “I could so get used to this.”")])])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page37"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-676940e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/5bodiestodiefor_ch03.vue
// module id = 75
// module chunks = 0